import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'Index',
    //   component: (resolve) => { require(['../pages/Index'], resolve)},
    // },
    {
      path: '/',
      name: 'Login',
      component: (resolve) => { require(['../pages/Login'], resolve)},
    },
    {
      path: '/Commitment',
      name: 'Commitment',
      component: (resolve) => { require(['../pages/Commitment'], resolve)},
      meta: { title: '考试承诺书' }
    },
    {
      path: '/Examtype',
      name: 'Examtype',
      component: (resolve) => { require(['../pages/Examtype'], resolve)},
      meta: { title: '选择考试类型' }
    }, 
    {
      path: '/Indentity',
      name: 'Indentity',
      component: (resolve) => { require(['../pages/Indentity'], resolve)},
      meta: { title: '身份认证' }
    },
    {
      path: '/UploadAvatar',
      name: 'UploadAvatar',
      component: (resolve) => { require(['../pages/UploadAvatar'], resolve)},
      meta: { title: '身份认证' }
    },
    {
      path: '/BasicInfo',
      name: 'BasicInfo',
      component: (resolve) => { require(['../pages/BasicInfo'], resolve)},
      meta: { title: '学历及工作信息' }
    },
    {
      path: '/Others',
      name: 'Others',
      component: (resolve) => { require(['../pages/Others'], resolve)},
      meta: { title: '其他资料' }
    },
    {
      path: '/Comfirm',
      name: 'Comfirm',
      component: (resolve) => { require(['../pages/Comfirm'], resolve)},
      meta: { title: '选择考区' }
    },
    {
      path: '/CheckStatus',
      name: 'CheckStatus',
      component: (resolve) => { require(['../pages/CheckStatus'], resolve)},
      meta: { title: '查看审核情况' }
    },
    {
      path: '/MyExam',
      name: 'MyExam',
      component: (resolve) => { require(['../pages/MyExam'], resolve)},
      meta: { title: '查看资料' }
    },
    {
      path: '/MakeUpExam',
      name: 'MakeUpExam',
      component: (resolve) => { require(['../pages/MakeUpExam'], resolve)},
      meta: { title: '选择考区并确认资料' }
    },
    {
      path: '/Result',
      name: 'Result',
      component: (resolve) => { require(['../pages/Result'], resolve)},
      meta: { title: '报名结果' }
    }
    // {
    //   path: '/choosecity',
    //   name: 'ChooseCity',
    //   component: (resolve) => { require(['../pages/ChooseCity'], resolve)}
    // },
    // {
    //   path: '/basicinfo',
    //   name: 'BasicInfo',
    //   component: (resolve) => { require(['../pages/BasicInfo'], resolve)}
    // },
    // {
    //   path: '/applyresult',
    //   name: 'ApplyResult',
    //   component: (resolve) => { require(['../pages/ApplyResult'], resolve)}
    // },
    // {
    //   path: '/checkagain',
    //   name: 'CheckAgain',
    //   component: (resolve) => { require(['../pages/CheckAgain'], resolve)}
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js